import { useState } from 'react';
import usePageMeta from '../../utils/usePageMeta';
import './QuienesSomos.css';

const VALUES = [
  {
    color: 'blue',
    icon: '/icons/quienes/Icon-7.svg',
    title: 'Transparencia',
    desc: 'Operamos con total claridad en cada proceso, garantizando confianza y credibilidad.',
  },
  {
    color: 'red',
    icon: '/icons/quienes/Icon-9.svg',
    title: 'Compromiso',
    desc: 'Nos dedicamos completamente a nuestros clientes y sus necesidades.',
  },
  {
    color: 'orange',
    icon: '/icons/quienes/Icon-2.svg',
    title: 'Innovación',
    desc: 'Buscamos constantemente nuevas formas de mejorar y facilitar la gestión administrativa.',
  },
  {
    color: 'green',
    icon: '/icons/quienes/Icon-8.svg',
    title: 'Trabajo en equipo',
    desc: 'Creemos en la colaboración y el apoyo mutuo para alcanzar objetivos comunes.',
  },
];

const APPROACH = [
  {
    icon: '/icons/quienes/Icon-6.svg',
    title: 'Simplificar procesos complejos',
    desc: 'Transformamos procesos complicados en flujos de trabajo simples y eficientes',
  },
  {
    icon: '/icons/quienes/Icon-5.svg',
    title: 'Automatizar tareas repetitivas',
    desc: 'Eliminamos el trabajo manual mediante automatización inteligente',
  },
  {
    icon: '/icons/quienes/Icon-4.svg',
    title: 'Mejorar la organización de la administración',
    desc: 'Estructura administrativa para mayor control',
  },
  {
    icon: '/icons/quienes/Icon-3.svg',
    title: 'Optimizar el tiempo de trabajo',
    desc: 'Maximizamos la productividad liberando tiempo valioso',
  },
];

const TRAINING_GALLERY = [
  '/images/quienes/quienes-training-1.png',
];

export default function QuienesSomos() {
  const [slide, setSlide] = useState(0);
  const total = TRAINING_GALLERY.length;

  usePageMeta({
    title: '¿Quiénes Somos? — Sistemas Administrativos S.A.',
    description:
      'Empresa argentina especializada en software para administradores de consorcios desde 1980. Conocé nuestros valores, equipo y forma de trabajar.',
  });

  const goPrev = () => setSlide((s) => (s - 1 + total) % total);
  const goNext = () => setSlide((s) => (s + 1) % total);

  return (
    <div className="quienes">
      {/* HERO */}
      <section className="quienes-hero">
        <div className="container">
          <h1 className="quienes-hero__title">¿Quiénes Somos?</h1>

          <div className="quienes-hero__inner">
            <div className="quienes-hero__copy">
              <p>
                Somos una empresa especializada en el desarrollo de soluciones tecnológicas para
                Administradores de Consorcios de Propiedad Horizontal.
              </p>
              <p>
                Desde 1980 acompañamos la evolución del sector, brindando herramientas que
                simplifican la gestión administrativa, contable e impositiva. Nuestra experiencia
                nos permite entender en profundidad las necesidades reales de las administraciones
                y ofrecer soluciones prácticas, confiables y en constante mejora.
              </p>
            </div>
            <div className="quienes-hero__visual">
              <img src="/images/quienes/quienes-hero.png" alt="Sistemas Administrativos" />
            </div>
          </div>
        </div>

        <svg
          className="quienes-hero__wave"
          aria-hidden="true"
          viewBox="0 0 1440 80"
          preserveAspectRatio="none"
        >
          <path d="M0,40 C240,0 480,0 720,40 C960,80 1200,80 1440,40 L1440,80 L0,80 Z" />
        </svg>
      </section>

      {/* EVOLUCIÓN E INNOVACIÓN */}
      <section className="quienes-evolution">
        <div className="container">
          <h2 className="quienes-evolution__title">Evolución e innovación</h2>
          <div className="quienes-evolution__subtitle">
            <p>
              A lo largo de los años hemos incorporado nuevas tecnologías para adaptarnos a los
              cambios del mercado. Hoy contamos con un ecosistema de plataformas 100% online que
              permiten trabajar de forma ágil, segura y desde cualquier lugar.
            </p>
            <p>
              Nuestro sistema principal, ADA 5 Web, funciona completamente en la nube, sin
              necesidad de instalaciones ni mantenimiento por parte del usuario.
            </p>
            <p>Además, ofrecemos:</p>
          </div>

          <div className="quienes-evolution__grid">
            <article className="evolution-card evolution-card--blue">
              <div className="evolution-card__media">
                <img src="/images/quienes/quienes-evolution-cer.jpg" alt="Consorcios en Red" />
                <div className="evolution-card__media-overlay" aria-hidden="true" />
                <div className="evolution-card__icon" aria-hidden="true">
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.5 19a4.5 4.5 0 1 0-1.4-8.78 7 7 0 1 0-12 6.18A4 4 0 0 0 7 19h10.5z" />
                  </svg>
                </div>
              </div>
              <div className="evolution-card__body">
                <h3 className="evolution-card__title">Consorcios en Red</h3>
                <p className="evolution-card__desc">
                  Una plataforma pensada para propietarios, donde pueden consultar su información,
                  descargar comprobantes y acceder a sus expensas en cualquier momento.
                </p>
              </div>
            </article>

            <article className="evolution-card evolution-card--violet">
              <div className="evolution-card__media">
                <img src="/images/quienes/quienes-evolution-sueldos.jpg" alt="ADA Sueldos" />
                <div className="evolution-card__media-overlay" aria-hidden="true" />
                <div className="evolution-card__icon" aria-hidden="true">
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="1" x2="12" y2="23" />
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                  </svg>
                </div>
              </div>
              <div className="evolution-card__body">
                <h3 className="evolution-card__title">ADA Sueldos</h3>
                <p className="evolution-card__desc">
                  Un sistema integrado para la liquidación de sueldos y la gestión de obligaciones
                  laborales del consorcio.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* VALORES */}
      <section className="quienes-values">
        <div className="container">
          <div className="quienes-values__pill">
            <span className="quienes-values__pill-dot" aria-hidden="true" />
            NUESTROS VALORES
          </div>
          <h2 className="quienes-values__title">Los principios que nos guían</h2>
          <p className="quienes-values__subtitle">
            Valores fundamentales que definen quiénes somos y cómo trabajamos
          </p>

          <div className="quienes-values__grid">
            {VALUES.map((v) => (
              <article key={v.title} className={`value-card value-card--${v.color}`}>
                <div className="value-card__icon">
                  <img src={v.icon} alt="" />
                </div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* COMPROMISO */}
      <section className="quienes-commitment">
        <div className="container">
          <h2>Compromiso con nuestros clientes</h2>
          <div className="quienes-commitment__body">
            <p>Creemos en la cercanía y el acompañamiento constante.</p>
            <p>
              Por eso, además del software, brindamos asesoramiento y soporte para que cada
              administración pueda aprovechar al máximo nuestras herramientas.
            </p>
            <p>
              Uno de los aspectos que nos diferencia es nuestro sector de consultoría, enfocado en
              brindar un acompañamiento real y continuo a cada cliente.
            </p>
            <p>
              No nos limitamos a ofrecer un sistema: trabajamos en conjunto con las administraciones
              para ayudarlas a resolver dudas, optimizar procesos y enfrentar los desafíos cotidianos
              de la gestión.
            </p>
            <p>
              Nuestro equipo de consultores brinda soporte, capacitación y asesoramiento permanente,
              manteniendo una relación cercana y directa con cada cliente.
            </p>
          </div>
        </div>
      </section>

      {/* NUESTRA FORMA DE TRABAJAR (incluye Combinamos) */}
      <section className="quienes-approach">
        <div className="container">
          <h2 className="quienes-approach__title">Nuestra forma de trabajar</h2>
          <p className="quienes-approach__intro">
            Combinamos tecnología, experiencia y acompañamiento permanente para
            <br />
            brindar un servicio integral.
          </p>
          <p className="quienes-approach__subtitle">Nos enfocamos en:</p>

          <div className="quienes-approach__grid">
            {APPROACH.map((a) => (
              <article key={a.title} className="approach-card">
                <div className="approach-card__icon">
                  <img src={a.icon} alt="" />
                </div>
                <div className="approach-card__text">
                  <h3>{a.title}</h3>
                  <p>{a.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CAPACITACIONES */}
      <section className="quienes-training">
        <div className="container">
          <h2 className="quienes-training__title">
            Capacitaciones, Cursos y cercanía con las administraciones
          </h2>
          <p className="quienes-training__subtitle">
            Contamos con un auditorio completamente equipado donde realizamos eventos,
            capacitaciones y cursos especializados para nuestros clientes.
          </p>

          <div
            className="quienes-training__carousel"
            aria-roledescription="carousel"
            aria-label="Capacitaciones"
          >
            <div
              className="quienes-training__viewport"
              aria-live="polite"
              aria-atomic="true"
            >
              <div
                className="quienes-training__track"
                style={{ transform: `translateX(-${slide * 100}%)` }}
              >
                {TRAINING_GALLERY.map((src, idx) => (
                  <div key={src} className="training-slide">
                    <img src={src} alt={`Capacitación SASA — sesión ${idx + 1}`} />
                  </div>
                ))}
              </div>
            </div>

            {total > 1 && (
              <>
                <button
                  type="button"
                  className="quienes-training__arrow quienes-training__arrow--left"
                  aria-label="Anterior"
                  onClick={goPrev}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M10 3.33L5.33 8L10 12.67" stroke="#0A0A0A" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button
                  type="button"
                  className="quienes-training__arrow quienes-training__arrow--right"
                  aria-label="Siguiente"
                  onClick={goNext}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 3.33L10.67 8L6 12.67" stroke="#0A0A0A" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>

                <div
                  className="quienes-training__dots"
                  role="tablist"
                  aria-label="Selector de slides"
                >
                  {TRAINING_GALLERY.map((_, idx) => (
                    <button
                      key={idx}
                      type="button"
                      role="tab"
                      className={`quienes-training__dot${idx === slide ? ' quienes-training__dot--active' : ''}`}
                      aria-label={`Slide ${idx + 1}`}
                      aria-selected={idx === slide}
                      onClick={() => setSlide(idx)}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
